import React from "react"
import DraggableWindow from "../../../../components/DraggableWindow"
import { MathKatex2 } from "../../../../components/MathKatex"
import { CDN_PUB_URL_PRACTICE_TESTS_SAT_VIRTUAL_TESTS } from "../../../../constants"
import "./Reference.css"

export default function Reference(props) {
    let {currentModuleNameKey, customClass, onClose} = props
    let content = getReferenceContent(currentModuleNameKey)

    return (
        <DraggableWindow title="Reference Sheet" draggable={true} maximized={true} onClose={onClose} customClass={customClass}>
            <div className="reference-container">
                <div className="reference-info">
                   {content}
               </div>
           </div>
        </DraggableWindow>
    )
}

//--- Helpers ---
function getReferenceContent(currentModuleNameKey: string) {
    let mathImg = "MathReference.png"
    let mathImgUrl = `${CDN_PUB_URL_PRACTICE_TESTS_SAT_VIRTUAL_TESTS}/${mathImg}`

    return (
        <div className="math-reference">
            <img src={mathImgUrl} alt="Math reference" />

            {/* 
            <p>
                The number of degrees of arc in a circle is 360.
            </p>
            <p>
                <MathKatex2 mixedContent="The number of radians of arc in a circle is `2\pi`." classNameForMath="computer-test-math"/>
            </p>
            <p>
                The sum of the measures in degrees of the angles of a triangle is 180.
            </p> 
            */}
        </div>
    )
}